'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGbSctAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 -2.03848e-05H-1.52588e-05V20H28V-2.03848e-05Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0003 -0.00360107H0.000310183V19.9964H28.0003V-0.00360107Z",
          fill: "#1479D0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0004 8.38815L1.50002 1.01328e-05L-1.52588e-05 -2.03848e-05L2.02656e-05 2.00001L11.616 9.99644L-1.52588e-05 17.5V20L1.50002 20L14.0004 11.6047L26.5 20L28 20V18L16.3847 9.99644L28 2V-2.03848e-05L26.5 0L14.0004 8.38815Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagGbSctAsset = forwardRef(FlagGbSctAsset);

export { VpFlagGbSctAsset as default };
